import { httpClientBlog } from './microservice-http-clients';

export const getBlogList = () => httpClientBlog.get('/');
export const getBlogData = slug => httpClientBlog.get(`/blog/${slug}`);
